import { appConfig } from 'config/environment/appConfig'

import { HttpService } from 'services/HttpService'

import { CountryByIpDTO } from './types'

const ipApiService = new HttpService(appConfig.IP_API_URL)

export const cookieService = {
  // Запрос к ip-api.com для получения данных по текущему IP
  getCountryByIp: async (): Promise<CountryByIpDTO> => {
    return await ipApiService.get<CountryByIpDTO>('', { disableToken: true, requestFromPromo: true })
  },
}
